/**
 * components/VoiceRecorder.js — Дуу хоолой бичих (МОБАЙЛТАЙ АДИЛ арга).
 *
 * Аудиог нэг удаа бичээд backend руу илгээж таниулна — hse_mobile-ийн
 * VoiceRecorderBar-тай ижил урсгал:
 *   1. MediaRecorder-оор аудио бичнэ (opus, бага битрейт).
 *   2. Зогсоход → backend `/api/mobile/hazard/speech` (STT)-руу илгээж
 *      текст таниулна (монгол хэл найдвартай — браузерын Web Speech API БИШ).
 *   3. Аудио файлыг MinIO-д хадгална (`/api/mobile/hazard/photo`).
 *
 * Props:
 *   onTranscript(text)     — танигдсан текст
 *   onAudioUploaded(url)   — MinIO-д хадгалагдсан дуу хоолойн файлын URL
 *   disabled
 */
import React, { useEffect, useRef, useState } from "react";
import { uploadHazardVoice, transcribeSpeech } from "src/api/hazard";

/**
 * Аюулын дуут тайлбарын ДЭЭД хугацаа (мс).
 *   • Аюул тайлбарлахад 30 секунд хангалттай (ердийн хэрэглээ 10-20 сек).
 *   • Chimege квот секундээр тоологддог (нийт 28,800 сек) — хэрэглэгч товч
 *     дараад мартсан тохиолдолд квот шатахаас сэргийлнэ.
 *   • 30 сек аудио ≈ 2 сек боловсруулалт → backend-ийн 25 сек төсөвт багтана.
 */
const MAX_RECORD_MS = 30_000;
/** Үүнээс богино бол санамсаргүй товшилт гэж үзэж илгээхгүй. */
const MIN_RECORD_MS = 1_000;
/** Сүүлийн энэ хугацаанд тоолуур улаан болно ("яараарай" дохио). */
const WARN_TAIL_MS = 10_000;

const fmt = (ms) => {
  const t = Math.max(0, Math.floor(ms / 1000));
  return `${String(Math.floor(t / 60)).padStart(2, "0")}:${String(t % 60).padStart(2, "0")}`;
};

export default function VoiceRecorder({
  onTranscript,
  onAudioUploaded,
  disabled,
  /* ⚠ НЯГТ ХУВИЛБАР — товчийг хэсгийн ГАРЧГИЙН мөрөнд тавихад.
     Текст талбарын ДООР тусдаа мөр эзлэхгүй тул маягт ~44px богиносно
     (2026-10-01, хэрэглэгчийн хүсэлт: «дэлгэцийн зай арай багасах»).
     Бичиж байх үеийн явцын зураасыг нягт хувилбарт ГАРГАХГҮЙ — гарчгийн
     мөр нь нарийн тул зураас орвол гарчиг хоёр мөр болж, зай хэмнэсэн
     нь дэмий болно. Тоолуур нь үлдэнэ (хэдэн секунд болсныг мэдэх нь
     чухал). */
  compact = false,
}) {
  const [recording, setRecording] = useState(false);
  const [processing, setProcessing] = useState(false); // таниж/хадгалж байна
  /* НӨӨЦ цөм ажилласан бол түүний нэр (хэвийн үед хоосон) */
  const [provider, setProvider] = useState("");
  const [error, setError] = useState("");
  const [elapsedMs, setElapsedMs] = useState(0);

  const streamRef = useRef(null); // микрофоны stream
  const mediaRef = useRef(null); // MediaRecorder
  const chunksRef = useRef([]);
  const tickerRef = useRef(null); // тоолуурын interval
  const startedAtRef = useRef(0); // бичлэг эхэлсэн мөч

  const stopTicker = () => {
    if (tickerRef.current) {
      clearInterval(tickerRef.current);
      tickerRef.current = null;
    }
  };

  const nearLimit = MAX_RECORD_MS - elapsedMs <= WARN_TAIL_MS;

  // Бичлэг дуусахад — backend STT-ээр таниулж, MinIO-д хадгална (мобайлтай адил)
  const handleStop = async () => {
    stopTicker();
    if (streamRef.current) {
      streamRef.current.getTracks().forEach((t) => t.stop());
      streamRef.current = null;
    }
    const durationMs = startedAtRef.current
      ? Date.now() - startedAtRef.current
      : 0;
    const blob = new Blob(chunksRef.current, {
      type: chunksRef.current[0]?.type || "audio/webm",
    });
    // Өмнө нь энэ хоёр тохиолдолд ЧИМЭЭГҮЙ буцдаг байсан — хэрэглэгч товч
    // дарсан хэрнээ юу ч болоогүй мэт харагддаг байв.
    if (!blob.size) {
      setError("Дуу бичигдсэнгүй. Микрофоны эрхээ шалгаад дахин оролдоно уу.");
      return;
    }
    if (durationMs > 0 && durationMs < MIN_RECORD_MS) {
      // Санамсаргүй товшилт — квот дэмий зарцуулж, хогтой бүртгэл үүсгэхгүй.
      setError("Хэт богино. Дахин бичиж, тодорхой ярина уу.");
      return;
    }

    setProcessing(true);
    // 1) Текст таниулалт — backend (мобайлтай ижил endpoint)
    try {
      const res = await transcribeSpeech(blob);
      const text = String(res?.transcript || "").trim();
      /* ── ЯМАР ЦӨМ ТАНИСАН БЭ (2026-11-04) ──────────────────────────
         Backend нь `provider`-ыг буцаадаг: "chimege-long" | "chimege" |
         "egune" | "google-sdk" | "google-rest".

         ⚠ ЯАГААД ХАРУУЛАХ ЁСТОЙ ВЭ: Chimege-ийн токен буруу, дууссан
           эсвэл БҮТЭЭГДЭХҮҮН ЗӨРСӨН (STT-Long ↔ STT) үед код нь
           ЧИМЭЭГҮЙ Egune рүү буудаг. Хэрэглэгч текст гарсаар байгаа тул
           «ажиллаж байна» гэж ойлгоод, зөвхөн чанар л мууддаг — иймэрхүү
           доройтол сар турш анзаарагдахгүй байж болно.
           Токен солих үед (хувийн → үйлдвэрийн) яг үүнийг барих ёстой.
         ⚠ ХЭВИЙН үед ЮУ Ч ХАРУУЛАХГҮЙ: «chimege» бол тэмдэг гарахгүй —
           эс бөгөөс хэрэглэгч өдөр тутмын ажилдаа хэрэггүй техникийн
           бичвэр уншина. Зөвхөн НӨӨЦ зам ажилласан үед л хэлнэ. */
      const prov = String(res?.provider || "");
      setProvider(prov.startsWith("chimege") ? "" : prov);
      if (text) {
        // Хөрвүүлсэн текстийг тайлбар хэсэгт залгана (тусдаа харуулахгүй)
        onTranscript?.(text);
      } else {
        setError("Яриа таниагдсангүй. Дахин оролдоно уу.");
      }
    } catch (err) {
      // Backend-ийн жинхэнэ шалтгааныг харуулна (жиш ffmpeg байхгүй)
      setError(
        err?.response?.data?.message || "Дуу таниулахад алдаа гарлаа.",
      );
    }
    // 2) Аудио файл хадгалах — MinIO (текст амжилтгүй байсан ч)
    if (onAudioUploaded) {
      try {
        const up = await uploadHazardVoice(blob);
        if (up?.file_url) onAudioUploaded(up.file_url);
      } catch {
        /* аудио хадгалагдаагүй ч текст үлдэнэ — алгасна */
      }
    }
    setProcessing(false);
  };

  const start = async () => {
    setError("");
    /* ⚠ Шинэ бичлэг эхлэхэд НӨӨЦ ЦӨМийн тэмдгийг ч арилгана:
       өмнөх оролдлогын тэмдэг үлдвэл Chimege ажилласан ч
       «нөөц цөм» гэж ХУДЛАА харагдана. */
    setProvider("");
    try {
      // Яриа таниулалтад тохирсон урсгал — моно, шуугиан/цуурай дарах,
      // автомат түвшин тэгшитгэх. Эдгээр нь Chimege-ийн таних чанарт шууд
      // нөлөөлнө.
      const stream = await navigator.mediaDevices.getUserMedia({
        audio: {
          channelCount: 1,
          echoCancellation: true,
          noiseSuppression: true,
          autoGainControl: true,
        },
      });
      streamRef.current = stream;
      let mr;
      try {
        mr = new MediaRecorder(stream, {
          mimeType: "audio/webm;codecs=opus",
          // ⚠ Энэ нь БИТ/СЕК, sample rate БИШ. Өмнө нь 16000 (16 kbps)
          // байсан — opus-ийн хэт шахсан горим бөгөөд яриа таних нарийвчлалыг
          // мэдэгдэхүйц бууруулдаг. 48 kbps нь ярианд бараг алдагдалгүй.
          audioBitsPerSecond: 48000,
        });
      } catch {
        mr = new MediaRecorder(stream);
      }
      chunksRef.current = [];
      mr.ondataavailable = (e) => {
        if (e.data && e.data.size) chunksRef.current.push(e.data);
      };
      mr.onstop = handleStop;
      mediaRef.current = mr;
      mr.start();
      startedAtRef.current = Date.now();
      setElapsedMs(0);
      setRecording(true);

      // Тоолуур + дээд хугацаанд хүрвэл АВТОМАТААР зогсоно. Хэрэглэгч товч
      // дараад мартсан ч бичлэг 30 секундээс хэтрэхгүй.
      tickerRef.current = setInterval(() => {
        const ms = Date.now() - startedAtRef.current;
        setElapsedMs(ms);
        if (ms >= MAX_RECORD_MS) {
          stopTicker();
          setError(
            `${MAX_RECORD_MS / 1000} секундын хязгаарт хүрлээ. ` +
              "Бичсэн хэсэг хадгалагдсан.",
          );
          stop();
        }
      }, 250);
    } catch {
      setError("Микрофон эхлүүлж чадсангүй. Зөвшөөрөл өгнө үү.");
    }
  };

  const stop = () => {
    stopTicker();
    if (mediaRef.current && mediaRef.current.state === "recording") {
      mediaRef.current.stop();
    }
    setRecording(false);
  };

  // Компонент устахад микрофоныг заавал сулла — тоолуур ажилласаар үлдэхгүй.
  useEffect(() => {
    return () => {
      stopTicker();
      if (streamRef.current) {
        streamRef.current.getTracks().forEach((t) => t.stop());
      }
    };
  }, []);

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: 10,
        flexWrap: "wrap",
      }}
    >
      <button
        type="button"
        disabled={disabled || processing}
        onClick={recording ? stop : start}
        title={recording ? "Бичлэгийг зогсоох" : "Дуугаар бичүүлэх"}
        style={{
          display: "inline-flex",
          alignItems: "center",
          gap: compact ? 5 : 7,
          padding: compact ? "3px 9px" : "7px 14px",
          borderRadius: 8,
          border: "1px solid",
          borderColor: recording ? "#CF1322" : "#1B6B45",
          background: recording ? "#FFF1F0" : "#F6FBF8",
          color: recording ? "#CF1322" : "#1B6B45",
          fontSize: compact ? 11.5 : 13,
          fontWeight: 600,
          whiteSpace: "nowrap",
          cursor: disabled || processing ? "not-allowed" : "pointer",
          opacity: disabled || processing ? 0.6 : 1,
        }}
      >
        {recording ? (
          <>
            <span
              style={{
                width: 9,
                height: 9,
                borderRadius: "50%",
                background: "#CF1322",
                display: "inline-block",
                animation: "vr-pulse 1s infinite",
              }}
            />
            Зогсоох
          </>
        ) : (
          <>🎤 {compact ? "Хоолой бичих" : "Дуу хоолойгоор бичих"}</>
        )}
      </button>

      {recording && (
        // Тоолуур + явцын зураас. Тусдаа анхааруулах цонх гаргахгүй —
        // ердийн бичлэг бүр дээр гарвал хэрэглэгч анзаарахаа больдог.
        // Сүүлийн 10 секундэд улаан болж "яараарай" гэдгийг мэдэгдэнэ.
        <span
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: 8,
            fontSize: 12,
            color: nearLimit ? "#CF1322" : "#9A988F",
            fontWeight: nearLimit ? 700 : 400,
          }}
        >
          <span style={{ fontVariantNumeric: "tabular-nums" }}>
            {fmt(elapsedMs)} / {fmt(MAX_RECORD_MS)}
          </span>
          {/* Явцын зураас — зөвхөн ӨРГӨН хувилбарт (дээрх тайлбарыг үз) */}
          <span
            style={{
              display: compact ? "none" : "block",
              width: 90,
              height: 4,
              borderRadius: 2,
              background: "#E8E6DF",
              overflow: "hidden",
            }}
          >
            <span
              style={{
                display: "block",
                height: "100%",
                width: `${Math.min(100, (elapsedMs / MAX_RECORD_MS) * 100)}%`,
                background: nearLimit ? "#CF1322" : "#1B6B45",
                transition: "width .25s linear",
              }}
            />
          </span>
        </span>
      )}
      {processing && (
        <span style={{ fontSize: 12, color: "#9A988F" }}>
          🔎 Таниж, хадгалж байна...
        </span>
      )}
      {/* ── НӨӨЦ ЦӨМ АЖИЛЛАСНЫ ТЭМДЭГ (2026-11-04) ──────────────────
          Chimege (монгол хэлний цөм) унавал код нь Egune/Google рүү
          чимээгүй буудаг. Текст гарсаар байдаг тул доройтол
          анзаарагдахгүй — тиймээс ЗӨВХӨН тэр үед жижиг тэмдэг гаргана.
          ⚠ Алдаа БИШ, АНХААРУУЛГА: бичлэг хадгалагдсан, текст ч
            гарсан. Иймд улаан биш шар өнгө. */}
      {provider && (
        <span
          title={
            "Монгол хэлний цөм (Chimege) ажиллаагүй тул «" +
            provider +
            "» нөөц цөмөөр таньсан — текстийн чанар доогуур байж " +
            "магад. Админд мэдэгдвэл токеныг шалгана."
          }
          style={{ fontSize: 11.5, color: "#B45309", whiteSpace: "nowrap" }}
        >
          <i
            className="fas fa-triangle-exclamation"
            style={{ marginRight: 4 }}
          />
          нөөц цөм ({provider})
        </span>
      )}
      {error && (
        <span style={{ fontSize: 12, color: "#CF1322" }}>{error}</span>
      )}

      <style>{`@keyframes vr-pulse {0%,100%{opacity:1}50%{opacity:0.25}}`}</style>
    </div>
  );
}
